import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import sorn from "../assets/img/icon/sorn.svg";

const Modalgallery = ({ dataUrl, ...datat }) => {
  const [activeIndex, setActiveIndex] = useState(datat.active);
  const carouselRef = useRef(null);

  const handleDragStart = (e) => e.preventDefault();
  // console.log(datat.active)
  const responsive = {
    0: { items: 1 },
    568: { items: 1 },
    1024: { items: 1 },
  };

  // ✅ useEffect ที่จะทำงานเมื่อ Modal เปิด
  useEffect(() => {
    // เช็คว่า Modal กำลังแสดงผลอยู่ และ carouselRef มีค่า
    if (datat.show && carouselRef.current) {
      const timeout = setTimeout(() => {
        // 1. เลื่อนไปรูปถัดไป เพื่อบังคับให้ Carousel คำนวณ layout
        if (datat.active === 0) {
          setActiveIndex(1);
          carouselRef.current.slidePrev();

        } else {
          setActiveIndex(datat.active-1);
          carouselRef.current.slideNext();
        }// carouselRef.current.slideTo(datat.active);

        // 2. ตั้งเวลาสั้นๆ แล้วเลื่อนกลับมาที่ตำแหน่งเดิม
        setTimeout(() => {
          carouselRef.current.slideTo(datat.active);
          console.log(datat.active)
        }, 10);

      }, 300); // ตั้งเวลาเพื่อให้ Modal มีเวลา Render ตัวเอง

      return () => clearTimeout(timeout);
    }
  }, [datat.show, datat.active]);

  return (
    <>
      <Modal
        {...datat}
        className="modal-gallery"
        size="lg"
        backdrop="static"
        centered
        keyboard={false}
      >
        <Modal.Header closeButton closeVariant="white" className="px-0">
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 ">
          <div className="d-block w-100 scroll-custom">
            <div className="h-100per-modal">
              <div className="gallery-full">
                <AliceCarousel
                  ref={carouselRef}
                  mouseTracking
                  responsive={responsive}
                  infinite
                  controlsStrategy="alternate"
                  disableDotsControls
                  activeIndex={activeIndex}
                  autoHeight
                  renderPrevButton={() => (
                    <p className="" style={{ left: "30px" }}>
                      <img src={sorn} className="sorn-left" alt="previous" />
                    </p>
                  )}
                  renderNextButton={() => (
                    <p className="" style={{ right: "30px" }}>
                      <img src={sorn} className="sorn-right" alt="next" />
                    </p>
                  )}
                >
                  {datat.gallery.map((value, index) => (
                    <div key={index} className="text-center">
                      <img
                        src={value}
                        onDragStart={handleDragStart}
                        className="img-fluid"
                        style={{ maxHeight: "100%", objectFit: "contain" }}
                        alt={`Gallery item ${index + 1}`}
                      />
                    </div>
                  ))}
                </AliceCarousel>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Modalgallery;